module.exports = __webpack_public_path__ + "static/media/gn.6bab8b1e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gn.svg
// module id = 660
// module chunks = 0